import React, { Component } from 'react';
import axios from 'axios';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.getCGI = this.getCGI.bind(this);
  }

  getCGI() {
    const url = "scripts/";
    console.log(`Querying ${url}`);

    axios.get(url).then((response) => {
      console.log(response);
      this.refs.content.innerHTML = response.data;
    }).catch((err) => {
      console.log(err);
      this.refs.content.innerHTML = err;
    });
  }

  render() {
    return (
      <div className="App">
        <h1>
          Arrhenius Project Test
        </h1>
        <hr/>
        <p ref="content">
          "The sincere friends of this world are as
          <br/>ship lights in the stormiest of nights"
          <br/>The Bloor Banner 12-13
        </p>
        <button onClick={this.getCGI}>Replace Text</button>
      </div>
    );
  }
}

export default App;
